<template>
  <div class="w-100 bg-white">
    <div id="search-room"></div>
    <SearchRoomHeader />

    <!-- ROOM -->
    <div
      class="ga-container fluid mb-5 bg-white position-relative"
      v-if="
        iActiveHotelModuleRoom || getMerchant.additional_appearance === 'CART'
      ">
      <div
        id="search-room-middle"
        class="position-absolute"
        style="top: -130px; left: 0px"></div>
      <HotelRoomFilterGeneral
        v-if="$is_tablet_lower_view"
        section="search"
        @loadRoomList="loadRoomListFromFilter" />
      <div class="row mb-5">
        <div class="col-12 col-lg-9 order-2 order-lg-1">
          <HotelRoomFilterGeneral
            :section="$is_tablet_lower_view ? 'result' : 'all'"
            :total-room-result="totalRoomResult"
            @loadRoomList="loadRoomListFromFilter" />

          <div v-if="getBePromotionFilterId" class="mb-3">
            <BePromotionFilterChip @clear="clearPromotionFilter" />
          </div>

          <div class="w-100 position-relativei">
            <div
              id="search-room-result"
              class="position-absolute"
              style="top: -420px; left: 0px" />
          </div>
          <div v-if="showRoomList && hasDigitalMap" class="d-flex justify-content-end mb-3">
            <div
              class="text-center py-2 rounded-4 px-3 d-inline-block cursor-pointer"
              :class="{ 'border-green': view_mode == 'list' }"
              @click="toggleViewMode('list')"
              style="border: 1px solid #dee2e6">
              <p
                class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14"
                :class="{ 'font-bold text-green': view_mode == 'list' }">
                {{ $t('hotel.map-toggle-list') }}
              </p>
            </div>
            <div
              class="text-center py-2 rounded-4 ml-2 px-3 d-inline-block cursor-pointer"
              :class="{ 'border-green': view_mode == 'map' }"
              @click="toggleViewMode('map')"
              style="border: 1px solid #dee2e6">
              <p
                class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14"
                :class="{ 'font-bold text-green': view_mode == 'map' }">
                {{ $t('hotel.map-toggle-map') }}
              </p>
            </div>
          </div>

          <BeDigitalMap
            v-if="showMapView"
            :maps="rootMapList"
            :merchant-id="getMerchant.id"
            :selected-map-id.sync="active_root_map_id"
            :is-searching="room.isLoading"
            @select-room-type="openMapRoomType" />

          <b-skeleton-wrapper v-else :loading="room.isLoading || is_map_checking">
            <template #loading>
              <template v-if="$is_mobile_view">
                <b-card body-class="p-0" class="mb-4" v-for="i in 2" :key="i">
                  <b-skeleton-img
                    no-aspect
                    width="100%"
                    height="150px"
                    card-img="top" />
                  <b-card-body>
                    <div class="mb-2">
                      <b-skeleton width="80%" height="25px" />
                    </div>
                    <b-row class="slim-grid-row">
                      <b-col cols="3">
                        <b-skeleton width="100%" height="20px" />
                      </b-col>
                      <b-col cols="3">
                        <b-skeleton width="100%" height="20px" />
                      </b-col>
                    </b-row>
                    <b-row class="slim-grid-row">
                      <b-col cols="3">
                        <b-skeleton width="80%" height="20px" />
                      </b-col>
                      <b-col cols="3" offset="6">
                        <b-skeleton width="100%" height="20px" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </template>
              <template v-else>
                <b-row class="mb-2" v-for="i in 2" :key="i">
                  <b-col cols="4">
                    <b-card body-class="p-0">
                      <b-skeleton-img
                        no-aspect
                        width="100%"
                        height="160px"
                        card-img="top" />
                      <b-card-body>
                        <div class="mb-2">
                          <b-skeleton width="80%" height="30px" />
                        </div>
                        <b-row class="slim-grid-row">
                          <b-col cols="3">
                            <b-skeleton width="100%" height="20px" />
                          </b-col>
                          <b-col cols="3">
                            <b-skeleton width="100%" height="20px" />
                          </b-col>
                        </b-row>
                        <b-skeleton width="30%" height="20px" class="my-2" />
                        <b-row class="slim-grid-row">
                          <b-col cols="3" offset="9">
                            <b-skeleton width="100%" height="37px" />
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card>
                  </b-col>
                  <b-col cols="8">
                    <div class="w-100 mb-3" v-for="j in 2" :key="j">
                      <b-card body-class="p-3">
                        <b-row>
                          <b-col cols="6">
                            <b-skeleton
                              width="100%"
                              height="30px"
                              class="mb-2" />
                            <b-skeleton
                              width="50%"
                              height="15px"
                              class="mb-2" />
                            <b-skeleton
                              width="30%"
                              height="15px"
                              class="mb-2" />
                            <b-skeleton
                              width="40%"
                              height="15px"
                              class="mb-2" />
                            <b-skeleton
                              width="20%"
                              height="20px"
                              class="mb-0" />
                          </b-col>
                          <b-col cols="6">
                            <b-skeleton
                              width="40%"
                              height="30px"
                              class="ml-auto" />
                            <b-skeleton
                              width="15%"
                              height="15px"
                              class="ml-auto" />
                            <b-skeleton
                              width="45%"
                              height="15px"
                              class="ml-auto mb-2" />
                            <b-skeleton
                              width="35%"
                              height="30px"
                              class="ml-auto" />
                            <b-skeleton
                              width="15%"
                              height="15px"
                              class="ml-auto" />
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                  </b-col>
                </b-row>
              </template>
            </template>

            <div class="w-100">
              <template v-if="room.list.length == 0">
                <div class="text-center py-4 mb-2">
                  <BeMembershipPromoLoginBanner class="mb-3" @logged-in="loadRoomList()" />
                  <FlexibleDateAlternatives
                    @dates-loaded="flexible_dates = $event; flexible_dates_loading = false"
                    @select-date="applyFlexibleDate" />
                  <template v-if="!flexible_dates_loading && flexible_dates.length == 0">
                    <img src="../../../assets/img/icon/404.png" width="200" />
                    <template v-if="$isNotEmptyV2(room.error)">
                      <p class="mb-1 mt-3 body-2-2 text-22 font-bold">
                        {{ room.error }}
                      </p>
                      <p class="mb-1 mt-3 body-2-2 text-22 font-bold">
                        {{ $t('hotel.error.404') }}
                      </p>
                    </template>
                    <p class="mb-3 body-2-2 font-semibold">
                      {{ $t('hotel.error.404-desc') }}
                    </p>
                  </template>
                  <button
                    class="button-primary bg-white px-4 text-black mt-3"
                    @click="resetAllFilter()">
                    {{ $t('hotel.filter.reset-filter') }}
                  </button>
                </div>
              </template>

              <div class="w-100" v-else>
                <FlexibleDateAlternatives
                  v-if="isAllRoomsSoldOut"
                  class="mb-3"
                  @dates-loaded="flexible_dates = $event; flexible_dates_loading = false"
                  @select-date="applyFlexibleDate" />
                <div class="w-100" v-if="$is_mobile_view">
                  <template v-for="(type, index) in room.list">
                    <BeRoomMobile
                      @room_type_detail="toggleRoomTypeDetail"
                      @room_rate_detail="toggleRoomRateDetail"
                      @room_rate_add="toggleRoomRateAdd"
                      @more_room="openMoreRoomInput"
                      design-type="NEW"
                      :rt_hightlight_index="roomRateHighlightIndex"
                      :roomRateHighlight="roomRateHighlight"
                      :data="type"
                      :type_index="index"
                      :type_avlb="getRoomAvlb(type.id)"
                      :header_scroll="false"
                      :selected_room_rate="roomRateDetail"
                      :type="mobilePopupType" />
                  </template>
                </div>
                <div v-else class="bg-light-desktop p-2 rounded-4">
                  <template v-for="(type, index) in room.list">
                    <BeRoomDesktop
                      @room_type_detail="toggleRoomTypeDetail"
                      @toggleRateBreakdown="toggleRateBreakdown"
                      @toggleBookingRate="toggleBookingRate"
                      @toggleBookingRateCart="toggleBookingRateCart"
                      @handlePopupFilter="toggleBackdrop"
                      :rt_hightlight_index="roomRateHighlightIndex"
                      :roomRateHighlight="roomRateHighlight"
                      :type="type"
                      :type_index="index"
                      :type_avlb="getRoomAvlb(type.id)"
                      :is_active="getBeSortBy"
                      :discountAccumulation="discountAccumulation"
                      :totalRateBreakdown="totalRateBreakdown"
                      :is_booking_dropdown="is_booking_dropdown"
                      :show_rate="show_rate"
                      :show_rate_breakdown="show_rate_breakdown">
                    </BeRoomDesktop>
                  </template>
                </div>
              </div>
            </div>
          </b-skeleton-wrapper>
        </div>

        <div class="col-12 col-lg-3 order-1 order-lg-2 position-relative">
          <div
            v-if="$isNotEmptyV2(publicPromoCodeWithBanner)"
            class="w-100 mb-4">
            <flickity ref="flickity" :options="$fullSliderOption">
              <div
                class="carousel-cell w-100"
                :id="promoCodeBanner.id"
                v-for="promoCodeBanner in publicPromoCodeWithBanner">
                <div
                  class="w-100 radius-8 overflow-hidden"
                  style="height: 200px">
                  <img
                    :src="promoCodeBanner.popup_image"
                    @click="selectPromoCode(promoCodeBanner)"
                    class="img-fit" />
                </div>
              </div>
            </flickity>
          </div>
          <PotentialPromotion
            v-if="getMerchant.search_room_is_show_promotion_highlight" />
          <div :class="{ 'preview-cart-desktop': !$is_tablet_lower_view }">
            <SearchPreviewCart module="ADDITIONAL" />
          </div>

          <ClaimingReward wrapper_class="mt-5" />
        </div>
      </div>
    </div>

    <!-- ADDITIONAL SERVICE -->
    <div
      class="ga-container fluid bg-white"
      v-if="
        !iActiveHotelModuleRoom &&
        getMerchant.additional_appearance === 'SEARCH_ROOM'
      ">
      <div class="row mb-5">
        <div class="col-12 col-lg-9">
          <div class="w-100 mb-5">
            <HotelProductTab />
          </div>
          <AdditionalModule />
        </div>
        <div class="col-12 col-lg-3 order-1 order-lg-2 position-relative">
          <div
            :class="{ 'preview-cart-module-desktop': !$is_tablet_lower_view }">
            <SearchPreviewCart module="ADDITIONAL" />
          </div>
        </div>
      </div>
    </div>

    <!-- LOCATION & NEARBY -->
    <div class="ga-container fluid mb-5">
      <BeLocationNearby />
    </div>

    <Footer />

    <!-- ROOM TYPE DETAIL -->
    <transition name="fade">
      <roomTypeDetailDesktop
        v-if="$isNotEmptyV2(roomTypeDetail) && !$is_mobile_view"
        @detailRoom="toggleRoomTypeDetail()"
        @handlePopupFilter="toggleBackdrop"
        :detail_room_type="roomTypeDetail" />

      <roomTypeDetailMobile
        v-if="$isNotEmptyV2(roomTypeDetail) && $is_mobile_view"
        @closeDetailRoom="toggleRoomTypeDetail()"
        :data="roomTypeDetail" />

      <roomRateDetail
        v-if="
          $isNotEmptyV2(roomRateDetail) &&
          mobilePopupType === 'room_rate' &&
          $is_mobile_view"
        :more_room_form="showMoreRoomSelection"
        :show-more-room-only="getMerchant.search_room_is_show_room_rate_detail"
        :data="roomRateDetail"
        @close="toggleRoomRateDetail" />
    </transition>

    <!-- General Backdrop -->
    <transition name="fade">
      <PopUpBackground
        v-if="isBackdropActive"
        @handlePopupFilter="toggleBackdrop"
        :data="isBackdropActive"></PopUpBackground>
    </transition>

    <popupConfirmation
      stack-on-top
      :show="popupConfirmation.show"
      :title="popupConfirmation.title"
      :subtitle="popupConfirmation.subtitle"
      @hide="setConfirmationModal"
      @apply="confirmFilterChangeSearch" />

    <!-- ROOM TYPE PICKED FROM THE DIGITAL MAP -->
    <BeMapRoomModalLegacy
      :is-mobile="$is_mobile_view"
      design-type="NEW"
      :room-type-id="mapRoomTypeId"
      :room-type-name="mapRoomTypeName"
      :search-params="map_search_params"
      :get-room-avlb="getRoomAvlb"
      :rt-hightlight-index="roomRateHighlightIndex"
      :room-rate-highlight="roomRateHighlight"
      :is-booking-dropdown="is_booking_dropdown"
      :show-rate="show_rate"
      :show-rate-breakdown="show_rate_breakdown"
      :is-active="getBeSortBy"
      :total-rate-breakdown="totalRateBreakdown"
      :selected-room-rate="roomRateDetail"
      :popup-active="mobilePopupType"
      @close="closeMapRoomType"
      @select-date="applyMapFlexibleDate"
      @room_type_detail="toggleRoomTypeDetail"
      @toggleRateBreakdown="toggleRateBreakdown"
      @toggleBookingRate="toggleBookingRate"
      @toggleBookingRateCart="toggleBookingRateCart"
      @handlePopupFilter="toggleBackdrop"
      @room_rate_detail="toggleRoomRateDetail"
      @room_rate_add="toggleRoomRateAdd"
      @more_room="openMoreRoomInput" />
  </div>
</template>

<script>
import { get } from '@/services/index.js';
import { mapGetters, mapMutations } from 'vuex';
import SearchRoomHeader from '../../../components/hotel/be/SearchRoomHeader.vue';
import AdditionalModule from '../../../components/hotel/be/AdditionalModule.vue';
import BeRoomDesktop from '@/components/hotel/be/desktop/room';
import BeRoomMobile from '@/components/hotel/be/mobile/room';
import BeDigitalMap from '@/components/hotel/be/v3/BeDigitalMap.vue';
import BeMapRoomModalLegacy from '@/components/hotel/be/v3/BeMapRoomModalLegacy.vue';
import {
  pushHistoryStep,
  releaseHistoryStep,
  abandonHistorySteps,
} from '@/utils/historyStep.js';
import { resolveDefaultViewMode } from '@/utils/beViewMode.js';
import SearchPreviewCart from '../../../components/hotel/be/SearchPreviewCart.vue';
import PotentialPromotion from '@/components/hotel/be/PotentialPromotion.vue';
import FlexibleDateAlternatives from '@/components/hotel/be/FlexibleDateAlternatives.vue';
import BeMembershipPromoLoginBanner from '@/components/hotel/be/BeMembershipPromoLoginBanner.vue';
import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
import Footer from '@/components/hotel/Footer';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
import roomTypeDetailDesktop from '@/components/hotel/be/desktop/roomTypeDetail';
import roomTypeDetailMobile from '@/components/hotel/be/mobile/roomTypeDetail';
import roomRateDetail from '@/components/hotel/be/mobile/roomRateDetail';
import HotelRoomFilterGeneral from '../../../components/hotel/be/HotelRoomFilterGeneral.vue';
import HotelProductTab from '../../../components/hotel/HotelProductTab.vue';
import popupConfirmation from '../../../components/general/popupConfirmation.vue';
import { trackEvent } from '../../../utils/analytics';
import BeLocationNearby from '@/components/hotel/be/v3/BeLocationNearby.vue';
import { isSameBeFilter } from '../../../utils/index.js';
import { resolveUsablePromoCode } from '@/utils/bePromoCode.js';
import { withPromotionFilter } from '@/utils/bePromotionFilter.js';
import BePromotionFilterChip from '@/components/hotel/be/v3/BePromotionFilterChip.vue';
import moment from 'moment';

export default {
  props: ['promoCodePopup'],
  components: {
    SearchRoomHeader,
    AdditionalModule,
    BeRoomDesktop,
    BeRoomMobile,
    BeDigitalMap,
    BeMapRoomModalLegacy,
    SearchPreviewCart,
    PotentialPromotion,
    FlexibleDateAlternatives,
    BeMembershipPromoLoginBanner,
    ClaimingReward,
    Footer,
    PopUpBackground,
    roomTypeDetailDesktop,
    roomTypeDetailMobile,
    roomRateDetail,
    HotelRoomFilterGeneral,
    HotelProductTab,
    popupConfirmation,
    BeLocationNearby,
    BePromotionFilterChip,
  },
  data() {
    return {
      room: {
        isLoading: true,
        error: '',
        list: [],
        typeAvailabilty: [],
      },
      isBackdropActive: false,
      roomTypeDetail: {},
      roomRateDetail: {},
      show_rate: false,
      show_rate_breakdown: false,
      is_booking_dropdown: false,
      is_booking_rate_cart: [],
      showMoreRoomSelection: false,
      mobilePopupType: '',
      flexible_dates: [],
      flexible_dates_loading: true,
      lastSearchedFilter: null,
      pendingSearch: null,
      popupConfirmation: {
        show: false,
        title: '',
        subtitle: '',
      },
      view_mode: 'list',
      // set once loadRoomList runs at least once -- lets toggleViewMode skip
      // a redundant search on repeated list<->map switches
      hasSearchedRoomList: false,
      map_list: [],
      // true until the map list answers -- the page cannot know whether to
      // show the map or run a search before then, so neither is rendered yet
      is_map_checking: true,
      active_root_map_id: null,
      map_room_type_ref: null,
      map_search_params: {},
    };
  },
  computed: {
    isAllRoomsSoldOut() {
      if (!this.room.list || this.room.list.length == 0) return false;
      return this.room.list.every((type) =>
        type.room_rate.every(
          (rate) => !rate.bookable || this.$roomAvbl(rate.room_type.id, rate.id) <= 0
        )
      );
    },
    ...mapGetters([
      'getMerchant',
      'iActiveHotelModuleRoom',
      'getBeFilter',
      'getBeCartRoom',
      'getBeSortBy',
      'getBePrice',
      'getCurrentLanguage',
      'getMembershipReferral',
      'getMembershipRewardApplied',
      'isNotLogin',
      'getBeFilterDetail',
      'getBeSortBy',
      'getBeRoomAvbl',
      'getSelectedPromotion',
      'getBePromotionFilterId',
      'getCurrentUser'
    ]),
    showSpecificFilter() {
      return this.$isNotEmptyV2(this.getBeFilterDetail.data);
    },
    roomRateHighlightIndex() {
      return this.room.list.findIndex((room) => {
        const match = this.getBeRoomAvbl.find((r) => r.id === room.id);
        return match ? match.original_availability > 0 : false;
      });
    },
    roomRateHighlight() {
      if (!this.room.list) return { roomTypeIndex: -1, roomRateIndex: -1 };

      let roomRateIndex = -1;

      const roomTypeIndex = this.room.list.findIndex((room) => {
        const availableRoom = this.getBeRoomAvbl.find(
          (avbl) => avbl.id === room.id
        );
        const isAvailable = availableRoom
          ? availableRoom.original_availability > 0
          : false;

        if (!isAvailable || roomRateIndex !== -1) return false;

        const index = room.room_rate.findIndex((rate) => rate.bookable);
        const hasBookableRate = index !== -1;

        if (hasBookableRate) {
          roomRateIndex = index;
          return true;
        }

        return false;
      });

      return { roomTypeIndex, roomRateIndex };
    },
    publicPromoCodeWithBanner() {
      if (this.$isEmpty(this.promoCodePopup)) return [];

      return this.promoCodePopup.filter((promo) =>
        this.$isNotEmptyV2(promo.popup_image)
      );
    },
    totalRoomResult() {
      if (this.$isEmpty(this.room.list)) return 'Find the best option';

      // stop-sell and closed rates still come back from search-room, but they are not offers
      const roomRate = this.room.list.reduce((accumulation, currentValue) => {
        return accumulation + currentValue.room_rate.filter((rate) => rate.bookable).length;
      }, 0);

      return `${roomRate} ${this.$pluralWord(roomRate, 'room offer')}`;
    },
    selectedPromotion() {
      const promotion = this.getSelectedPromotion;
      if (!promotion) return '';
      return promotion.id;
    },
    showRoomList() {
      return (
        this.iActiveHotelModuleRoom ||
        this.getMerchant.additional_appearance === 'CART'
      );
    },
    rootMapList() {
      const roots = this.map_list.filter((map) => map.is_root);
      // is_root is not filled in consistently across merchants -- when
      // nothing is flagged, every map the list endpoint returns is a
      // top-level one
      return roots.length > 0 ? roots : this.map_list;
    },
    hasDigitalMap() {
      return this.rootMapList.length > 0;
    },
    isMapModeActive() {
      return this.hasDigitalMap && this.view_mode == 'map';
    },
    showMapView() {
      return this.showRoomList && this.isMapModeActive;
    },
    mapRoomTypeId() {
      return this.map_room_type_ref ? this.map_room_type_ref.id : null;
    },
    mapRoomTypeName() {
      return this.map_room_type_ref ? this.map_room_type_ref.name : '';
    },
    beFilterDateSignature() {
      const { check_in, check_out } = this.getBeFilter.date;
      return `${this.$formatDateApi(check_in)}_${this.$formatDateApi(check_out)}`;
    },
  },
  watch: {
    /* An open popup was given the params of the dates it opened on. Rebuilding
       them here rather than in the search flow keeps the popup right whichever
       control moved the dates -- the carousel inside it, or the page's own
       search bar. */
    beFilterDateSignature() {
      if (this.map_room_type_ref) this.map_search_params = this.getParamsRoomList(false);
    },
    selectedPromotion() {
      // in map mode there is no list to refresh -- the popup picks the new
      // promotion up on its next open, when openMapRoomType rebuilds the params
      if (this.isMapModeActive) {
        this.closeMapRoomType();
        return;
      }
      if(!this.room.isLoading) {
        this.scrollToLoadedRoom();
        const validatePromotion = this.$isNotEmptyV2(this.selectedPromotion);
        this.loadRoomList(validatePromotion);
      }
    },
  },
  created() {
    /* Plain instance properties: a handle on the browser entry that mirrors an
       open layer is bookkeeping, not view state. */
    this.map_room_type_step = null;
    this.room_type_detail_step = null;
    this.view_mode = resolveDefaultViewMode(this.getMerchant);
  },
  mounted() {
    setTimeout(() => {
      this.$smoothScroll('search-room');
    }, 200);
    this.lastSearchedFilter = this.cloneFilter(this.getBeFilter);
    this.bootstrapResults();
  },
  beforeDestroy() {
    abandonHistorySteps();
  },
  methods: {
    ...mapMutations([
      'resetBeFilter',
      'resetSelectedPromotion',
      'resetBePromotionFilter',
      'setBeRoomAvbl',
      'setBeFilterDetail',
      'setSpecificBeFilter',
      'BeManipulateRoomRate',
    ]),
    scrollToLoadedRoom(){
      const selectedElement = `search-room-${this.$is_mobile_view ? 'result' : 'middle'}`
      this.$smoothScroll(selectedElement);
    },
    /* The map list decides which of the two result views the page is, so it
       has to answer before anything else runs -- a merchant with a map never
       calls search-room for the page at all. */
    async bootstrapResults() {
      await this.loadMapList();
      this.is_map_checking = false;
      // no map: a config default of 'map' has nothing to show
      if (!this.hasDigitalMap) this.view_mode = 'list';
      // map mode runs no search-room on bootstrap, so the initial loading state
      // must be released here or BeDigitalMap's overlay never clears
      if (this.isMapModeActive) {
        this.room.isLoading = false;
        return;
      }
      this.loadRoomList();
    },
    loadMapList() {
      return get('CORE_HOTEL', 'merchant-booking-map-list', {
        merchant_id: this.getMerchant.id,
      })
        .then((response) => {
          const res = response.data;
          if (res.success && this.$isNotEmptyV2(res.data)) this.map_list = res.data;
        })
        // a merchant whose map lookup fails still deserves a bookable page,
        // so treat the failure as "no map" and fall through to the list
        .catch(() => {});
    },
    openMapRoomType(roomTypeRef) {
      this.map_search_params = this.getParamsRoomList(false);
      this.map_room_type_ref = roomTypeRef;
      this.map_room_type_step = pushHistoryStep(this.dismissMapRoomType);
    },
    /* Browser Back: its history entry is already consumed, so drop the handle
       first and let the normal close path run without rewinding again. */
    dismissMapRoomType() {
      this.map_room_type_step = null;
      this.closeMapRoomType();
    },
    closeMapRoomType() {
      if (!this.map_room_type_ref) return;
      const step = this.map_room_type_step;
      this.map_room_type_step = null;
      this.map_room_type_ref = null;
      /* Rate Detail / Book Now inside the popup raise the page-level backdrop
         and leave show_rate* set. The popup owns the only row those flags refer
         to, so closing it has to clear them or the backdrop outlives it. */
      this.toggleBackdrop(false);
      // also rewinds past a room type detail stacked above, closing it too
      if (step) releaseHistoryStep(step);
    },
    // lazy-loads the room list the first time a MAP-default merchant's guest
    // switches to list, instead of always searching on page load
    toggleViewMode(mode) {
      this.view_mode = mode;
      if (mode == 'list' && !this.hasSearchedRoomList) {
        this.loadRoomList();
      }
    },
    loadRoomListFromFilter() {
      this.trackSearchClick();
      this.requestSearch(this.getBeFilter);
    },
    cloneFilter(filter) {
      return JSON.parse(JSON.stringify(filter));
    },
    buildDefaultFilter() {
      return {
        date: {
          check_in: new Date(),
          check_out: moment()
            .add(this.getMerchant.search_room_filter_default_total_night, 'd')
            .toDate(),
        },
        guest: {
          adult: this.getMerchant.search_room_filter_default_total_adult,
          child: 0,
          infant: 0,
        },
        promo_code: '',
      };
    },
    requestSearch(newFilter, commit = () => {}, options = {}) {
      const filterChanged = !isSameBeFilter(this.lastSearchedFilter, newFilter);
      const hasCartItems = this.getBeCartRoom.length > 0;

      if (!filterChanged) {
        commit();
        this.executeSearch(false, newFilter, options);
        return;
      }

      if (!hasCartItems) {
        commit();
        this.executeSearch(true, newFilter, options);
        return;
      }

      this.pendingSearch = { commit, newFilter, options };
      this.popupConfirmation = {
        show: true,
        title: this.$t('hotel.search-filter-changed-title'),
        subtitle: this.$t('hotel.search-filter-changed-desc'),
      };
    },
    setConfirmationModal(data = { show: false, title: '', subtitle: '' }) {
      this.popupConfirmation = data;
      if (!data.show) this.pendingSearch = null;
    },
    confirmFilterChangeSearch() {
      this.popupConfirmation = { show: false, title: '', subtitle: '' };
      if (!this.pendingSearch) return;
      const { commit, newFilter, options } = this.pendingSearch;
      this.pendingSearch = null;
      commit();
      this.executeSearch(true, newFilter, options);
    },
    executeSearch(shouldResetCart, newFilter, options = {}) {
      if (shouldResetCart) this.BeManipulateRoomRate('reset');
      this.lastSearchedFilter = this.cloneFilter(newFilter);
      this.scrollToLoadedRoom();
      /* Map mode reloads the list too, even though the map itself is
         filter-independent: it gives the Search button a real loading state to
         show over the map, refreshes availability in the store, and leaves the
         list warm for a later toggle. An open popup holds the params it was
         opened with, so close it rather than leave stale rates on screen --
         unless the search came from inside the popup itself (keepMapPopup),
         where the guest asked for this very room on other dates and the
         beFilterDateSignature watcher reloads it in place. */
      if (this.isMapModeActive && !options.keepMapPopup) this.closeMapRoomType();
      this.loadRoomList();
    },
    trackSearchClick() {
      this.$trackRoomSearch();
      if (!this.$hasGoogleTag()) return;
      this.$gtag('event','search', { method: 'Google' });
    },
    async loadRoomList(validateSelectedPromotion = false) {
      this.hasSearchedRoomList = true;
      try {
        this.room = {
          isLoading: true,
          error: '',
          list: [],
          typeAvailabilty: [],
        };
        this.flexible_dates = [];
        this.flexible_dates_loading = true;
        const apiParams = this.getParamsRoomList(validateSelectedPromotion);
        const apiResponse = await get('CORE_HOTEL', 'search-room', apiParams);
        const { success, message, data, room_type_availability } =
          apiResponse.data;

        if (!success) throw new Error(message);

        trackEvent('view_item_list', {
          params: apiParams,
          result: data
        })
        this.parsedRoomData(data, room_type_availability);
        if(this.$isNotEmptyV2(data) && this.$isNotEmptyV2(this.getMerchant.google_tag_manager_id)) this.sendUserGuestData(data[0], apiParams)
        this.$sendEventMetaConversionsAPI('Search');
      } catch (error) {
        this.room.error = error.message;
      } finally {
        this.room.isLoading = false;
      }
    },
    sendUserGuestData(bestRoom, filter){
      const { check_in_date: checkIn, check_out_date: checkOut, adult, child, infant } = filter;
      const bestRoomRate = bestRoom.room_rate[0];
      const params = { checkIn, checkOut, adult, child, infant,
        room: bestRoom.name,
        roomRate: bestRoomRate.name,
        bestPrice: bestRoomRate.dates.reduce((acc, value) => acc + value.final_price, 0)
      }
       
      this.$sendHotelUserGuestDataLayer("availability", params);
    },
    getParamsRoomList(validateSelectedPromotion) {
      try {
        const promotion = this.getParamsRoomListPromotion(validateSelectedPromotion);
        const stayDate = this.getParamsRoomListStayDate();
        const guests = this.getParamsRoomListGuest();
        const price = this.getParamsRoomListPrice();
        const membership = this.getParamsRoomListMembership();
        const specificFilter = this.getParamsRoomListSpecificFilter();

        return {
          ...promotion,
          ...stayDate,
          ...guests,
          ...price,
          ...membership,
          ...specificFilter,
          merchant_id: this.getMerchant.id,
          sort_by: this.getBeSortBy,
          language_code: this.getCurrentLanguage,
          device: 'desktop',
        };
      } catch (error) {
        throw error;
      }
    },
    getParamsRoomListPromotion(validateSelectedPromotion) {
      let params = { use_promotion_combine: true };
      const {
        promo_code,
        date: { check_in: startDate, check_out: endDate },
      } = this.getBeFilter;
      
      if (!validateSelectedPromotion && this.$isNotEmptyV2(promo_code)) {
        params.promo_code = promo_code;
        this.resetSelectedPromotion()
      }

      const isPromoCodeEmpty = this.$isEmpty(params.promo_code)
      const isPromoCodeMatch = this.$isNotEmptyV2(this.getSelectedPromotion.promo_code) && promo_code === this.getSelectedPromotion.promo_code;

      if(isPromoCodeEmpty || isPromoCodeMatch){
        const selected = this.$getSelectedPotentialPromotion({
          startDate,
          endDate,
        }, validateSelectedPromotion);

        if (this.$isNotEmptyV2(selected)){
          if(selected.promotion_type === 'PROMO_CODE') params.promo_code = selected.promo_code
          else params.promotion_affected = selected.id

          if(selected.promotion_type === 'MEMBERSHIP'){
            const { id: rewardId } = selected.membership_reward.reward;
            params.membership_reward_id = rewardId;
          }
        }
      }

      return withPromotionFilter(params, this.getBePromotionFilterId);
    },
    getParamsRoomListStayDate() {
      const { check_in, check_out } = this.getBeFilter.date;

      return {
        check_in_date: this.$formatDateApi(check_in),
        check_out_date: this.$formatDateApi(check_out),
      };
    },
    getParamsRoomListGuest() {
      const {
        search_room_is_show_filter_pax_child: useChild,
        search_room_is_show_filter_pax_infant: useInfant,
      } = this.getMerchant;

      const { adult, child, infant } = this.getBeFilter.guest;
      
      let params = {
        adult,
        child: useChild ? child : 0,
        infant: useInfant ? infant : 0,
      }

      if(!this.isNotLogin){
        params.user_id = this.getCurrentUser.id
      }
      
      return params;
    },
    getParamsRoomListPrice() {
      const isPriceEmpty = (price) => this.$isEmpty(price) || price === 0;

      return {
        price_min: isPriceEmpty(this.getBePrice[0]) ? '' : this.getBePrice[0],
        price_max: isPriceEmpty(this.getBePrice[1]) ? '' : this.getBePrice[1],
      };
    },
    getParamsRoomListMembership() {
      if (this.$isNotEmptyV2(this.getMembershipReferral)) {
        const { membership_referral_code, membership_reward_id } =
          this.getMembershipReferral;
        return { membership_referral_code, membership_reward_id };
      } else if (!this.isNotLogin) {
        const { id } = this.getMembershipRewardApplied;
        if(this.$isNotEmptyV2(id)){
          return { membership_reward_id: id };
        }
      }
      return {};
    },
    getParamsRoomListSpecificFilter() {
      if (!this.showSpecificFilter) return {};

      const {
        type,
        data: { id },
      } = this.getBeFilterDetail;
      return type === 'room_type' ? { room_type_id: id } : { rate_id: id };
    },
    parsedRoomData(rooms, roomAvailability) {
      this.room.list = rooms.map((roomType) => {
        roomType.room_rate = roomType.room_rate.map(
          (roomRate, roomRateIndex) => {
            const originalId = roomRate.id;
            roomRate.id_ori = originalId;
            roomRate.id = `${originalId}_${roomRateIndex}`;
            return roomRate;
          }
        );
        return roomType;
      });
      this.room.typeAvailabilty = roomAvailability.map((roomType) => {
        roomType.original_availability = roomType.availability;
        return roomType;
      });
      this.setBeRoomAvbl(this.room.typeAvailabilty);
    },
    resetAllFilter() {
      const defaultFilter = this.buildDefaultFilter();
      this.requestSearch(defaultFilter, () => {
        this.resetBeFilter();
        this.resetSelectedPromotion();
        this.resetBePromotionFilter();
      });
    },
    getRoomAvlb(roomTypeId) {
      let roomAvlb = this.getBeRoomAvbl.find((room) => room.id == roomTypeId);
      return roomAvlb ? roomAvlb.original_availability : 0;
    },
    discountAccumulation(counter, base) {
      let display = ((base - counter) * 100) / base;
      return +parseFloat(display).toFixed(2);
    },
    totalRateBreakdown(data) {
      let total_price_breakdown = 0;
      for (let i = 0; i < data.length; i++) {
        total_price_breakdown += data[i].final_price;
      }
      return total_price_breakdown;
    },
    clearFilterDetail() {
      this.setBeFilterDetail({ type: 'room_type', data: {} });
      this.loadRoomList();
    },
    clearPromotionFilter() {
      this.resetBePromotionFilter();
      if (this.isMapModeActive) this.closeMapRoomType();
      this.loadRoomList();
    },
    selectPromoCode(promotion) {
      const { promo_code } = promotion;
      this.setSpecificBeFilter([{ key: 'promo_code', value: promo_code }]);
      this.loadRoomList();
    },
    async applyFlexibleDate(dates) {
      const newFilter = await this.buildFlexibleDateFilter(dates);
      this.requestSearch(newFilter, () => this.commitFlexibleDateFilter(newFilter));
    },
    // same search, but the map popup that raised it stays open on the room the
    // guest picked the dates for
    async applyMapFlexibleDate(dates) {
      const newFilter = await this.buildFlexibleDateFilter(dates);
      this.requestSearch(newFilter, () => this.commitFlexibleDateFilter(newFilter), {
        keepMapPopup: true,
      });
    },
    // a wrong code carried in from the website plugin would fail the suggested dates too
    async buildFlexibleDateFilter({ check_in_date, check_out_date }) {
      const newFilter = this.cloneFilter(this.getBeFilter);
      newFilter.date = { check_in: check_in_date, check_out: check_out_date };
      newFilter.promo_code = await resolveUsablePromoCode(this.getMerchant.id, newFilter.promo_code);
      return newFilter;
    },
    commitFlexibleDateFilter({ date, promo_code }) {
      this.setSpecificBeFilter([
        { key: 'date', value: date },
        { key: 'promo_code', value: promo_code },
      ]);
    },
    toggleBackdrop(show = false) {
      this.isBackdropActive = show;
      if (!show) {
        this.show_rate = false;
        this.show_rate_breakdown = false;
        this.is_booking_dropdown = false;
        this.mobilePopupType = '';
        this.showMoreRoomSelection = false;
      }
    },
    toggleRoomTypeDetail(data = {}) {
      const isOpening = this.$isNotEmptyV2(data);
      this.roomTypeDetail = data;
      this.toggleBackdrop(isOpening);
      if (!isOpening) {
        this.releaseRoomTypeDetailStep();
        return;
      }
      /* Only while stacked on the map popup: reached from the plain room list
         this modal keeps its existing Back behaviour. */
      if (this.map_room_type_ref) {
        this.room_type_detail_step = pushHistoryStep(this.dismissRoomTypeDetail);
      }
    },
    dismissRoomTypeDetail() {
      this.room_type_detail_step = null;
      this.toggleRoomTypeDetail();
    },
    releaseRoomTypeDetailStep() {
      if (!this.room_type_detail_step) return;
      const step = this.room_type_detail_step;
      this.room_type_detail_step = null;
      releaseHistoryStep(step);
    },
    toggleRoomRateDetail(data = {}) {
      this.mobilePopupType = data == '' ? 'close' : 'room_rate';
      this.roomRateDetail = data;
      this.toggleBackdrop(this.$isNotEmptyV2(data) ? true : false);
    },
    toggleRoomRateAdd(data = {}) {
      this.mobilePopupType = data == '' ? 'close' : 'room_rate_add';
      this.roomRateDetail = data;
      this.toggleBackdrop(this.$isNotEmptyV2(data) ? true : false);
    },
    toggleRateBreakdown(type, data) {
      if (type == 'rates') {
        if (this.show_rate == data) {
          this.show_rate = false;
          return;
        }
        this.show_rate = data;
        this.toggleBackdrop(true);
      } else if (type == 'rates-breakdown') {
        if (this.show_rate_breakdown == data) {
          this.show_rate_breakdown = false;
          return;
        }

        this.show_rate_breakdown = data;
        this.show_rate = data;
        this.toggleBackdrop(true);
      }
    },
    toggleBookingRate(data) {
      if (this.is_booking_dropdown == data) {
        this.is_booking_dropdown = '';
        this.toggleBackdrop(false);
      } else {
        this.is_booking_dropdown = data;
        this.toggleBackdrop(true);
      }
    },
    toggleBookingRateCart(type, data, qty = 1) {
      let room_selected = data;
      if (type == 'add') {
        if (this.is_booking_rate_cart.length == 0) {
          room_selected['qty'] = qty;
          this.is_booking_rate_cart.push(room_selected);
        } else {
          let is_exist = false;
          for (let i = 0; i < this.is_booking_rate_cart.length; i++) {
            if (room_selected.id == this.is_booking_rate_cart[i].id) {
              is_exist = i;
              break;
            }
          }
          if (is_exist === false) {
            room_selected['qty'] = qty;
            this.is_booking_rate_cart.push(room_selected);
          } else {
            this.is_booking_rate_cart[is_exist].qty = qty;
          }
        }
      } else {
        this.is_booking_rate_cart.splice(data, 1);
      }
      this.is_booking_dropdown = false;
      this.show_rate = false;
    },
    openMoreRoomInput(data) {
      this.mobilePopupType = 'room_rate';
      this.showMoreRoomSelection = true;
      this.roomRateDetail = data;
    },
  },
};
</script>
<style>
.preview-cart-desktop {
  position: sticky;
  top: 100px;
  z-index: 1039 !important;
}
.preview-cart-module-desktop {
  position: sticky;
  top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/SearchRoomWithMultiImageBanner.vue